import { Card, CardContent, CircularProgress, Grid, Button, Icon } from '@material-ui/core';
import { Formik, Form, Field } from 'formik';
import React, { memo, useCallback } from 'react';
import { useObservable } from 'react-use-observable';
import { SelectFormField } from 'v2/components/Shared/FormFields/SelectFormField';
import { TextFormField } from 'v2/components/Shared/FormFields/TextFormField';
import whitelistService, { InitialFilter } from 'v2/services/whitelist';

import type { IFilter } from 'v2/interfaces/whitelist';

import FilterSchema from './validations';

import type { FormikProps } from 'formik';

const Filter = () => {
  const [isLoading] = useObservable(() => whitelistService.isLoading(), []);

  const CustomerTypeOptions = [
    {
      label: 'Nome',
      value: 'customer_name',
    },
    {
      label: 'E-mail',
      value: 'customer_email',
    },
    {
      label: 'CPF/CNPJ',
      value: 'customer_document',
    },
  ];

  const onSubmit = useCallback((values: IFilter, { setSubmitting, resetForm }: FormikProps<IFilter>) => {
    let newFilter: any = {};
    newFilter[values.type] = values[values.type];
    whitelistService.setFilter(newFilter);
    resetForm({ values });
    setSubmitting(false);
  }, []);

  return (
    <Card style={{ marginBottom: 16 }} elevation={0}>
      <CardContent>
        <Formik initialValues={InitialFilter} validationSchema={FilterSchema} onSubmit={onSubmit}>
          {({ values, isValid, isSubmitting, resetForm, setFieldValue }) => {
            const onChangeCustomerType = (e: React.ChangeEvent<HTMLInputElement>) => {
              const v = e.target.value;
              setFieldValue('customer_name', '');
              setFieldValue('customer_email', '');
              setFieldValue('customer_document', '');
              setFieldValue('type', v);
            };
            return (
              <Form id='whitelist-form'>
                <Grid container spacing={1}>
                  <Grid item xs={12} md={2}>
                    <Field
                      id='type'
                      name='type'
                      label='Cliente'
                      fullWidth
                      options={CustomerTypeOptions}
                      component={SelectFormField}
                      onChange={onChangeCustomerType}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Field
                      id={values.type}
                      name={values.type}
                      component={TextFormField}
                      fullWidth
                      label={values.type === 'customer_document' ? 'CPF/CNPJ' : values.type === 'customer_email' ? 'E-mail' : 'Nome'}
                      placeholder={
                        values.type === 'customer_name' ? 'Insira o nome' : values.type === 'customer_email' ? 'Insira o e-mail' : 'Insira o CPF/CNPJ'
                      }
                      mask={values.type === 'customer_document' ? 'document' : null}
                    />
                  </Grid>
                  <Grid item md={3}></Grid>
                  <Grid item xs={12} md={1}>
                    <Button
                      style={{ marginTop: 24 }}
                      disabled={isSubmitting || isLoading}
                      fullWidth
                      onClick={() => resetForm({ values: { type: values.type, customer_name: '', customer_document: '', customer_email: '' } })}
                    >
                      Limpar
                      {(isLoading || isSubmitting) && <CircularProgress size={10} style={{ color: '#192542', marginLeft: 10 }} />}
                    </Button>
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <Button
                      style={{ marginTop: 24 }}
                      variant='contained'
                      disabled={!isValid || isSubmitting || isLoading}
                      color='secondary'
                      fullWidth
                      type='submit'
                      startIcon={<Icon>filter_list</Icon>}
                    >
                      Filtrar
                      {(isLoading || isSubmitting) && <CircularProgress size={10} style={{ color: '#192542', marginLeft: 10 }} />}
                    </Button>
                  </Grid>
                </Grid>
              </Form>
            );
          }}
        </Formik>
      </CardContent>
    </Card>
  );
};

export default memo(Filter);
